"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInfo = getInfo;
exports.saveOrUpdate = saveOrUpdate;
var _request = _interopRequireDefault(require("@/utils/request"));
function saveOrUpdate(data) {
  return (0, _request.default)({
    url: '/portal/system/wechat/config/saveOrUpdate',
    method: 'post',
    data: data
  });
}
function getInfo(params) {
  return (0, _request.default)({
    url: '/portal/system/wechat/config/getByAppId',
    method: 'get',
    params: params
  });
}